import React from 'react';
import { Modal, Table, TableColumnsType } from 'antd';
import { InvoiceList } from '@/interfaces/seller';
import { formatDate, formatNumber } from '@/utilities/dataUtils';

interface IProps {
  open: boolean;
  invoiceList: InvoiceList[];
  onClose: () => void;
}

const InvoiceModal: React.FC<IProps> = ({ invoiceList, open, onClose }) => {
  const handleOk = () => {
    onClose();
  };

  const columns: TableColumnsType<InvoiceList> = [
    {
      title: '#',
      dataIndex: '',
      width: 40,
      align: 'center',
      className: 'text-bold',
      render: (_, rec, i) => <div className="font-weight-bold">{i + 1}</div>,
    },
    {
      title: 'เอกสาร INVOICE',
      dataIndex: 'ITEM_ID',
      align: 'center',
      className: 'text-bold',
      width: 120,
      fixed: 'left',
    },
    {
      title: 'วันที่เอกสาร',
      dataIndex: 'AR_DATE',
      align: 'center',
      className: 'text-bold',
      width: 120,
      render: (_) => formatDate(_),
    },
    {
      title: 'วันที่ครบกำหนด',
      dataIndex: 'EXPITYDATE_TIME',
      align: 'center',
      className: 'text-bold',
      width: 120,
      render: (_) => formatDate(_),
    },
    {
      title: 'ยอดเงิน',
      dataIndex: 'LINE_GRANDTOTALAMOUNT',
      align: 'right',
      className: 'text-bold',
      width: 120,
      render: (_) => formatNumber(_, 2),
    },
  ];

  return (
    <Modal
      title="รายการ INVOICE"
      open={open}
      onCancel={handleOk}
      footer={false}
      // onCancel={handleCancel}
      width={800}
    >
      <Table<InvoiceList>
        columns={columns}
        dataSource={invoiceList}
        size="small"
        bordered
        rowKey={'AR_NBR'}
        pagination={false}
        locale={{
          emptyText: 'ไม่พบรายการ',
        }}
      />
    </Modal>
  );
};

export default InvoiceModal;
